export default {
  user_event: {
    status: {
      visible: 'Visible',
      hidden: 'No visible',
      expired: 'Expirado',
    },
  },
};
